import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";

export const ViewCommitteeBatchApprovalConfig = {
  columns: [
    {
      name: "CPID",
      fieldName: "cpid",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Course Provider Name",
      fieldName: "courseProviderName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Submission Date",
      fieldName: "submissionDate",
      allowShort: false,
      colType: GridColumnType.DATE,
      colSettings: {
        format: 'DD MMM YYYY',
    }
    },
    {
      name: "Staff Approval Date",
      fieldName: "staffApprovalDate",
      colType: GridColumnType.DATE,
      colSettings: {
        format: 'DD MMM YYYY',
    }
    },

    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false,
      },
      customAction: [
        {
          name: "View",
          // onViewAction: (data) => {
          //     alert("called permissions");
          // },
        },
      ],
    },
  ],
};
export const ViewEventListConfig = {
    columns: [
      {
        name: "Event ID",
        fieldName: "eventNumber",
        allowShort: false,
        colType: GridColumnType.Text,
      },
      {
        name: "Event Title",
        fieldName: "eventTitle",
        allowShort: false,
        colType: GridColumnType.Text,
      },
      {
        name: "Event Date",
        fieldName: "eventDate",
        allowShort: false,
        colType: GridColumnType.DATE,
      colSettings: {
        format: 'DD MMM YYYY',
    }
      },
      {
        name: "Staff Approval Date",
        fieldName: "staffApprovalDate",
        colType: GridColumnType.DATE,
      colSettings: {
        format: 'DD MMM YYYY',
    }
      },
  
      {
        name: "Action",
        colType: GridColumnType.ACTION,
        defaultAction: {
          allowEdit: false,
          allowDelete: false,
        },
        customAction: [
          {
            name: "View",
            // onViewAction: (data) => {
            //     alert("called permissions");
            // },
          },
        ],
      },
    ],
  };